import { Component, OnInit, inject } from '@angular/core';
import { CourseItem } from '../../shared/core/state/course/models';
import { CourseService } from '../../shared/core/state/course/course.service';
import { Store } from '@ngrx/store';
import { State } from '../../shared/core/state';
import * as CourseActions from '../../shared/core/state/course/course.actions';
import { Router } from '@angular/router';
import { OrderService } from '../../shared/core/state/order/order.service';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface EnrolledCourseCardItem {
  course: CourseItem;
  enrollmentStatus: 'ACTIVE' | 'AWAITING_APPROVAL' | 'PENDING' | 'OVERDUE';
  isEnrolled: boolean;
  orderId?: string;
}

@Component({
  selector: 'black-my-courses',
  templateUrl: './my-courses.component.html',
  styleUrls: ['./my-courses.component.css'],
  standalone: false,
})
export class MyCoursesComponent implements OnInit {
  private store = inject<Store<State>>(Store);
  private router = inject(Router);
  private courseService = inject(CourseService);
  private orderService = inject(OrderService);

  courseItems: EnrolledCourseCardItem[] = [];
  isLoading = true;

  ngOnInit(): void {
    forkJoin({
      enrollments: this.courseService.getEnrollments().pipe(catchError(() => of([]))),
      pendingMap: this.orderService.getPendingCourseOrders(),
    }).subscribe({
      next: ({ enrollments, pendingMap }) => {
        const courses = enrollments || [];
        this.store.dispatch(
          CourseActions.fetchEnrollmentsSuccess({ enrolledCourses: courses })
        );

        const activeIds = new Set(courses.map((c) => c._id));
        const items: EnrolledCourseCardItem[] = courses.map((course) => {
          const pending = pendingMap.get(course._id);
          return {
            course,
            enrollmentStatus: pending ? pending.status : 'ACTIVE',
            isEnrolled: pending?.status !== 'OVERDUE',
            orderId: pending?.orderId,
          };
        });

        for (const [id, pending] of pendingMap) {
          if (!activeIds.has(id) && pending.course) {
            activeIds.add(id);
            items.push({
              course: pending.course,
              enrollmentStatus: pending.status,
              isEnrolled: false,
              orderId: pending.orderId,
            });
          }
        }

        this.courseItems = items;
        this.isLoading = false;
      },
    });
  }

  onCourseClick(courseId: string): void {
    this.router.navigate(['/courses', courseId, 'playlist']);
  }
}
